/**
 * Map elavon response to IW internal data schema
 *
 * @param {elavonResponse}
 * @returns {mappedElavonResponse}
 */

export const mapElavonResponse = elavonResponse => {
  const mappedElavonResponse = {
    receiptIdentifier: {
      authorizationCode: elavonResponse.ssl_approval_code || ""
    },
    transactionIdentifier: {
      localRequestId: elavonResponse.ssl_invoice_number || "",
      remoteRequestId: `ID:${elavonResponse.ssl_token || ""}`,
      merchantReferenceCode: elavonResponse.ssl_invoice_number || "",
      authorizationCode: elavonResponse.ssl_approval_code || "",
      originalTransactionType: elavonResponse.ssl_transaction_type || "",
      expirationDate: elavonResponse.ssl_exp_date || "",
      currentTotalAmount: elavonResponse.ssl_amount || "",
      accountToken: elavonResponse.ssl_token || "",
      cardType: elavonResponse.ssl_card_short_description || "",
      maskedCardNumber: elavonResponse.ssl_card_number || ""
    },
    transactionId: elavonResponse.ssl_txn_id || ""
  };

  if (elavonResponse.ssl_token_response === "SUCCESS") {
    mappedElavonResponse.cardToken = elavonResponse.ssl_token;
  }

  return mappedElavonResponse;
};

/**
 * Map elavon apple pay response to IW internal data schema
 *
 * @param {elavonResponse}
 * @param {invoiceNumber}
 * @returns {mappedElavonAPResponse}
 *
 */

export const mapElavonAPResponse = (elavonAPResponse, invoiceNumber) => {
  const mappedElavonAPResponse = {
    receiptIdentifier: {
      authorizationCode: elavonAPResponse.ssl_approval_code || ""
    },
    transactionIdentifier: {
      localRequestId: invoiceNumber || "",
      remoteRequestId: `ID:${elavonAPResponse.ssl_token || ""}`,
      merchantReferenceCode: invoiceNumber || "",
      authorizationCode: elavonAPResponse.ssl_approval_code || "",
      originalTransactionType: elavonAPResponse.ssl_transaction_type || "",
      expirationDate: elavonAPResponse.ssl_exp_date || "",
      currentTotalAmount: elavonAPResponse.ssl_amount || "",
      accountToken: elavonAPResponse.ssl_token || "",
      cardType: elavonAPResponse.ssl_card_short_description || ""
    },
    transactionId: elavonAPResponse.ssl_txn_id || ""
  };

  return mappedElavonAPResponse;
};
